import React, { useRef, useEffect, useState } from "react";

// Counts up to a numeric value when scrolled into view.
// Supports values like "10+", "4147+", "100%".
const AnimatedCounter = ({ value, duration = 1800, className = "" }) => {
  const match = String(value).match(/^([\d.,]+)(.*)$/);
  const target = match ? parseFloat(match[1].replace(",", ".")) : 0;
  const suffix = match ? match[2] : "";
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const step = (now) => {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setCount(target * eased);
              if (p < 1) requestAnimationFrame(step);
              else setCount(target);
            };
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [target, duration]);

  return (
    <span ref={ref} className={className}>
      {Math.round(count).toLocaleString("fr-FR")}
      {suffix}
    </span>
  );
};

export default AnimatedCounter;
